// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"71f1d147","977":"7a79432f"}[chunkId] + ".chunk.js";
};